module.exports = __webpack_public_path__ + "media/images/icons/outlined/pie-chart-2e85e9da9c5ac948f27f357e8ed25830.svg";